import { useId, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { COMMON_IMPERSONATION_REASONS } from "@/lib/impersonation-reasons";

export function ImpersonationReasonPicker({
  value,
  onChange,
  disabled = false,
  onConfirm,
  confirmLabel = "Bekreft impersonering",
}: {
  value: string;
  onChange: (reason: string) => void;
  disabled?: boolean;
  onConfirm: (reason: string) => void;
  confirmLabel?: string;
}) {
  const id = useId();
  const [otherSelected, setOtherSelected] = useState(false);
  const isPreset = COMMON_IMPERSONATION_REASONS.some((reason) => reason === value);
  const showOther = otherSelected || (!!value && !isPreset);

  return (
    <fieldset disabled={disabled} className="space-y-3">
      <legend className="mb-1.5 text-sm font-medium text-admin-text-primary">
        Grunn
      </legend>
      <div className="flex flex-wrap gap-1.5">
        {COMMON_IMPERSONATION_REASONS.map((reason) => (
          <Button
            key={reason}
            type="button"
            size="sm"
            disabled={disabled}
            aria-pressed={!showOther && value === reason}
            variant={!showOther && value === reason ? "secondary" : "outline"}
            onClick={() => {
              setOtherSelected(false);
              onChange(reason);
              onConfirm(reason);
            }}
          >
            {reason}
          </Button>
        ))}
        <Button
          type="button"
          size="sm"
          disabled={disabled}
          aria-pressed={showOther}
          variant={showOther ? "secondary" : "outline"}
          onClick={() => {
            setOtherSelected(true);
            if (!showOther) onChange("");
          }}
        >
          Annet
        </Button>
      </div>
      {showOther && (
        <div className="space-y-1.5">
          <label htmlFor={id} className="text-sm font-medium text-admin-text-primary">
            Annen grunn
          </label>
          <Input
            id={id}
            autoFocus
            disabled={disabled}
            value={value}
            onChange={(event) => {
              setOtherSelected(true);
              onChange(event.target.value);
            }}
          />
          {!!value.trim() && (
            <div className="flex justify-end pt-2">
              <Button
                type="button"
                disabled={disabled}
                onClick={() => {
                  const reason = value.trim();
                  if (!disabled && reason) onConfirm(reason);
                }}
              >
                {confirmLabel}
              </Button>
            </div>
          )}
        </div>
      )}
    </fieldset>
  );
}
